// extracted by mini-css-extract-plugin
export default {"tab":"SecondaryTab-module__tab__1BEWA","disabled":"SecondaryTab-module__disabled__Mxky3","active":"SecondaryTab-module__active__D64c5","icon":"SecondaryTab-module__icon__4VLxq"};